import $ from 'jquery';

$(document).on( 'click', '.wpcf7-checkbox.mc-optin', function() {
    const checkbox = $('input[type="checkbox"]', this);
    checkbox[0].checked = !checkbox[0].checked;
});
